import { ILaboratorioAnalise } from "@/interfaces/ILaboratorioAnalise";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";

interface ILaboratorioState {
  items: ILaboratorioAnalise[];
  synced: boolean;
}

const initialState: ILaboratorioState = {
  items: [],
  synced: false,
};

const laboratorioSlice = createSlice({
  name: "LABORATORIO",
  initialState,
  reducers: {
    sync: (state, action: PayloadAction<{ items: ILaboratorioAnalise[] }>) => {
      state.items = action.payload.items;
      state.synced = true;
    },
  },
});

export default laboratorioSlice.reducer;

export const getLaboratorioSynced = (state: RootState) =>
  state.laboratorio.items;
